import React  from "react";
import PageHero from "./PageHero";
import img13 from "../../media/images/garary/g16.jpg";
import img20 from "../../media/images/garary/blog1.jpg";
import img21 from "../../media/images/garary/reatrit.jpg";
import { Modal, Button } from "react-bootstrap";
import { useState } from "react";

function Blog() {
  const [show, setShow] = useState(false);
const [selectedPost, setSelectedPost] = useState(null);

const handleClose = () => setShow(false);

const handleShow = (post) => {
  setSelectedPost(post);
  setShow(true);
};

const posts = [
  {
    scr: img21,
    title: "Experience Peace Like Never Before",
    date: "April 2026",
    short: "Discover how our retreats can transform your spiritual journey.",
    full: "At Father’s House Church Resort Hotel, we offer a peaceful environment where you can reconnect with your inner self. Our retreats are carefully designed to help you relax, reflect, and grow spiritually. Surrounded by nature and guided sessions, you will leave refreshed and renewed."
  },
  {
    scr: img20,
    title: "Why Retreats Matter",
    date: "April 2026",
    short: "Understand the importance of taking time away.",
    full: "In today’s busy world, taking time away is essential. Our retreats provide the perfect opportunity to disconnect from stress and reconnect with what truly matters. With guided prayers, peaceful surroundings, and supportive community, you gain clarity and strength."
  },
  {
    scr: img13,
    title: "Comfort Meets Spirituality",
    date: "April 2026",
    short: "Enjoy both relaxation and growth in one place.",
    full: "We combine modern comfort with spiritual growth. Our facilities ensure you feel at home while focusing on your spiritual journey. Comfortable rooms, quality dining, and serene spaces create a balanced and fulfilling experience."
  }
];


  
   const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState("");

  const handleSubscribe = () => {

    // CHECK IF EMAIL IS EMPTY
    if (!email.trim()) {
      setError("Please enter your email address");
      setSubscribed(false);
      return;
    }

    // CLEAR ERROR
    setError("");

    // SHOW SUCCESS MESSAGE
    setSubscribed(true);

    // CLEAR INPUT
    setEmail("");

    // HIDE MESSAGE AFTER 4 SECONDS
    setTimeout(() => {
      setSubscribed(false);
    }, 4000);
  };


  
  return (
    <>
      {/* HERO */}
      <PageHero
        title="Blog"
        subtitle="Latest news and updates from Father’s House"
        image={img13}
      />

      {/* FEATURED POST */}
      <div className="container py-5">
        <div className="row align-items-center">
          
          <div className="col-md-6 mb-4" data-aos="fade-right">
            <img src={img20} className="img-fluid rounded shadow" alt="" />
          </div>

          <div className="col-md-6" data-aos="zoom-in">
            <h2>Featured Post</h2>
            <h4 className="mt-3">Experience Peace Like Never Before</h4>
            <p>
              Discover how our retreats and serene environment can transform
              your spiritual journey and bring inner peace.
            </p>
            <button
                   className="btn btn-success"
                   onClick={() => handleShow(posts[0])}
                 >
              Read Full Story
              </button>
          </div>
        </div>
      </div>

      {/* BLOG LIST */}
      <div className="container pb-5">
        <h3 className="text-center mb-4" data-aos="fade-up">
          Latest Articles
        </h3>

        <div className="row">
          {posts.map((post, index) => (
            <div
              className="col-md-4 mb-4"
              key={post}
              data-aos="zoom-in"
              data-aos-delay={index * 100}


              
            >
              <div className="card shadow h-100">
                <img src={post.scr} className="card-img-top" alt="Blog" />
                <div className="card-body d-flex flex-column">
                  <h5>{post.title}</h5>
                  <p className="text-muted small">{post.date}</p>
                  <p>{post.short}</p>
                  <button className="btn btn-success mt-auto"
                  onClick={() => handleShow(post)}
                  >
                    Read More
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CATEGORIES */}
      <div className="bg-light py-5">
        <div className="container text-center">
          <h3 className="mb-4" data-aos="fade-up">
            Explore Topics
          </h3>

          <div className="d-flex flex-wrap justify-content-center gap-3">
            <span className="badge bg-success p-3">Retreats</span>
            <span className="badge bg-success p-3">Events</span>
            <span className="badge bg-success p-3">Spiritual Growth</span>
            <span className="badge bg-success p-3">Accommodation</span>
          </div>
        </div>
      </div>

      {/* NEWSLETTER */}
      <div
        className="text-white text-center py-5"
        style={{
          backgroundImage: `url(${img13})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div style={{ background: "rgba(0,0,0,0.6)", padding: "40px" }}>
      <h2 data-aos="fade-up">Stay Updated</h2>

      <p data-aos="fade-up" className="mt-2">
        Subscribe to our newsletter for the latest updates and offers.
      </p>

      <div
        className="d-flex justify-content-center mt-3"
        data-aos="fade-up"
      >
        <input
          type="email"
          placeholder="Enter your email"
          className="form-control w-50 me-2"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button
          className="btn btn-success px-4"
          onClick={handleSubscribe}
        >
          Subscribe
        </button>
      </div>

       {/* ERROR MESSAGE */}
      {error && (
        <p className="text-danger mt-2 text-center">
          {error}
        </p>
      )}

      {/* SUCCESS MESSAGE */}
      {subscribed && (
        <div
          className="text-center mt-4"
          data-aos="zoom-in"
        >
          <div
            className="bg-success text-white p-4 rounded shadow-lg d-inline-block"
            style={{
              animation: "bounce 1s infinite",
            }}
          >
            <h4 className="mb-2">
              🎉 Congratulations!
            </h4>

            <p className="mb-0">
              You have successfully subscribed.
            </p>
          </div>
        </div>
      )}

      {/* ANIMATION */}
      <style>
        {`
          @keyframes bounce {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-10px);
            }
          }
        `}
      </style>
    </div>
        </div>
     
      <Modal show={show} onHide={handleClose} centered>
  <Modal.Header closeButton>
    <Modal.Title>
      {selectedPost ? selectedPost.title : ""}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {selectedPost && (
      <>
        <p className="text-muted">{selectedPost.date}</p>
        <p>{selectedPost.full}</p>
      </>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={handleClose}>
      Close
    </Button>
  </Modal.Footer>
</Modal>
    </>
  );
}

export default Blog;